<template>
  <div class="table-responsive border border-1 mc-table-overflow">
    <b-table
      show-empty
      class="table-wrapper"
      :fields="computedFields"
      :items="items"
      :foot-clone="isBusy && items.length > 0"
    >
      <template #empty>
        <div v-show="!isBusy" class="text-center my-4">Tidak ada data</div>
      </template>

      <template #cell(error)="data">
        <div :class="`status ${!data.value ? 'status--success' : 'status--failed'}`">
          <i v-if="!data.value" class="mc-icon icon-fill_checkmark"></i>
          <i v-else class="mc-icon icon-outline_close"></i>
        </div>
      </template>

      <template #cell()="{ value, field, item }">
        <div class="d-flex flex-column detail-row">
          <div class="detail-row__value">
            {{ value || '-' }}
          </div>
          <div class="detail-row__error">
            {{ item.error?.[field.showErrorKey] || '' }}
          </div>
        </div>
      </template>

      <template #head()="data">
        <div class="d-flex gap-3 justify-content-between">
          <span class="label">
            {{ data.label }}
          </span>
        </div>
      </template>

      <!-- For showing skeleton when fetching next page data, only rendered when items.length > 0, (see foot-clone attr) -->
      <template #foot()>
        <b-skeleton></b-skeleton>
      </template>
    </b-table>

    <!-- Observe visibility to get next page data -->
    <div
      v-observe-visibility="handleElementObserved"
      style="height: 2px"
      v-if="items.length > 0"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    listGetter: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      totalCount: 0,
      isBusy: false,
    }
  },
  computed: {
    hasNextPage() {
      return this.page * this.limit < this.totalCount
    },
    computedFields() {
      return [
        {
          key: 'error',
          label: '',
          thAttr: {
            style: 'min-width:40px;width:40px;',
          },
        },
        ...this.fields,
      ]
    },
  },
  watch: {
    sorts: {
      deep: true,
      handler() {
        this.getData(true)
      },
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      this.isBusy = true

      if (reset) {
        this.items = []
      }

      try {
        const res = await this.listGetter()
        this.items = res || []
        this.totalCount = this.items.length
      } catch (err) {
        console.error(err)
      }

      this.isBusy = false
    },
    handleElementObserved(isVisible) {
      if (!isVisible) return

      this.getData()
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(table) {
  td {
    position: relative;
    vertical-align: middle;
  }

  .label {
    white-space: nowrap;
    color: black;
  }

  .sort-icon-up,
  .sort-icon-down {
    position: absolute;
  }

  .sort-icon-up {
    top: 1px;
  }

  .sort-icon-down {
    bottom: 1px;
  }

  .status {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: grid;
    place-items: center;

    &--success {
      color: $green;
      background-color: $green-100;
    }

    &--failed {
      color: $red;
      background-color: #fee8e5;
    }
  }

  .detail-row {
    &__error {
      font-size: 10px;
      color: $red-400;
    }
  }
}
</style>
